import React from "react";
import styles from "../components/laymanComp_css/LaymanPage12.module.css";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/shakti.json";
export default function LaymanPage12() {
  return (
    <>
 <Common_html BlockData={BlockData} />
    </>
  );
}
